export default {
    Demand: 1, // số kiểm tra cấp dưới
    Deliver: 2, // quyết định giao
    New: 3, // Mới

}